<template>
  <div class="content-wrapper">
    <el-form label-width="200px" label-position="right" ref="searchForm" :model="formData"
      class="search-form" :inline="true" :rules="rules">
      <div class="flex-wrapper">
        <el-form-item label="系统对接版本" prop="sysDockVersion" class="">
          <el-select v-model="formData.sysDockVersion" size="small"
            placeholder="" class="" clearable @change='sysDockVersionChange'>
            <el-option :value="GAMECO" label="">GAMECO</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系统对接API地址" prop="sysDockAdd" class="">
          <el-input
            size="small" v-model="formData.sysDockAdd"
            placeholder="系统对接API地址" clearable class=""/>
        </el-form-item>
      </div>
      <div class="flex-wrapper">
        <el-form-item label="信息发送方式" prop="smsSendMethod" class="">
          <el-select v-model="formData.smsSendMethod" size="small"
            :disabled='formData.sysDockVersion===GAMECO'
            placeholder="" class="" clearable>
            <el-option value="1" label="短信猫"></el-option>
            <el-option value="2" label="企业微信"></el-option>
            <el-option value="3" label="阿里云"></el-option>
            <el-option value="4" label="钉钉"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户端登录认证方式" prop="loginMethod" class="">
          <el-select v-model="formData.loginMethod" size="small"
            placeholder="" class="" clearable :disabled='enableLoginMethod'>
            <el-option value="1" label="员工号"></el-option>
            <el-option value="2" label="手机号"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="flex-wrapper">
        <el-form-item label="qrcode-api-wsdl ">
          <el-input
            size="small" v-model="formData.wsdlUrl"
            placeholder="" clearable class=""/>
        </el-form-item>

        <el-form-item label="配送时录入领取人信息为" prop="deliveryReceiverType" class="">
          <el-select v-model="formData.deliveryReceiverType" size="small"
            placeholder="" class="" clearable>
            <el-option value="1" label="员工号"></el-option>
            <el-option value="2" label="手机号"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="flex-wrapper checkbox-wrapper">
        <el-form-item label="" prop="enableAuth" class="dis-checkbox-span">
          <el-checkbox v-model="formData.enableAuth"
            :disabled='checkboxEnableAD'>启动AD认证</el-checkbox>
        </el-form-item>
        <el-form-item label="" prop="allowSameDept" class="">
          <el-checkbox v-model="formData.allowSameDept"
            :disabled='checkboxEnable'>允许领料员领取同部门航材包</el-checkbox>
        </el-form-item>
        <el-form-item label="" prop="needLogin" class="">
          <el-checkbox v-model="formData.needLogin">领取航材必须登录</el-checkbox>
        </el-form-item>
        <el-form-item label="" prop="needSweep" class="">
          <el-checkbox v-model="formData.needSweep">领取退料必须扫描退料单号</el-checkbox>
        </el-form-item>
        <el-form-item label="" prop="needSweep" class="">
          <el-checkbox v-model="formData.checkRecordNumber">配送单号必须在ERP系统中存在</el-checkbox>
        </el-form-item>
      </div>
      <div class="btn-wrapper">
        <el-form-item label="" prop="" class="">
          <el-button type="danger" size="small" icon="el-icon-finished" @click="save">保存</el-button>
        </el-form-item>
        <el-form-item label="" prop="" class="">
          <el-button type="warning" size="small" icon="el-icon-finished" @click="openAliyun">打开阿里云配置</el-button>
        </el-form-item>
        <el-form-item label="" prop="" class="">
          <el-button type="primary" size="small" @click="configClient">下发配置到客户端</el-button>
        </el-form-item>
      </div>
    </el-form>

    <!-- 阿里云配置 -->
    <el-dialog :visible.sync="aliyunVisible" title="阿里云配置" :close-on-click-modal="false">
      <el-form label-width="210px" label-position="right" ref="aliyunForm" :model="aliyunForm">
        <div class="flex-wrapper aliyun-message-wrapper">
          <el-form-item label="阿里云短信服务地址"
            prop="messageServerAddress"
            :rules="[{ max: 50, message: '长度在 0 到 50 个字符', trigger: 'change' }]"
            >
            <el-input
              size="small" v-model="aliyunForm.messageServerAddress"
              max="50"

              @input="aliyunChange"
              placeholder="请填写域名" clearable class=""/>
          </el-form-item>
          <el-form-item  label="accessKeySecret"
            prop="accessKeySecret"
            :rules="[{ max: 50, message: '长度在 0 到 50 个字符', trigger: 'change' }]"
            >
            <el-input
              size="small" v-model="aliyunForm.accessKeySecret"

              show-password
              @input="aliyunChange"
              placeholder="请填写 accessKeySecret" clearable class="access-key-secret" />
          </el-form-item>
        </div>
        <div class="flex-wrapper">
          <el-form-item label="accessKeyId"
          prop="accessKeyId"
          :rules="[{ max: 50, message: '长度在 0 到 50 个字符', trigger: 'change' }]"
          >
          <el-input
            size="small" v-model="aliyunForm.accessKeyId"
            type="textarea"
            @input="aliyunChange"
            :rows="2"

            placeholder="请填写 accessKeyId" clearable class=""/>
          </el-form-item>
          <el-form-item label="短信签名"
            prop="signName"
            :rules="[{ max: 50, message: '长度在 0 到 50 个字符', trigger: 'change' }]"
           >
            <el-input
              size="small" v-model="aliyunForm.signName"
              type="textarea"
              @input="aliyunChange"
              :rows="2"

              placeholder="请填写短信签名" clearable class=""/>
          </el-form-item>
        </div>
        <div class="flex-wrapper">
          <el-form-item label="航材配送提醒短信模板ID"
            prop="toolDeliveryTemplateCode"
            :rules="[{ max: 50, message: '长度在 0 到 50 个字符', trigger: 'change' }]"
            >
            <el-input
              size="small" v-model="aliyunForm.toolDeliveryTemplateCode"
              type="textarea"
              @input="aliyunChange"
              :rows="2"
              max="50"

              placeholder="请填写航材配送提醒短信模板ID" clearable class=""/>
          </el-form-item>
          <el-form-item label="取消配送提醒短信模板ID"
            prop="cancelDeliveryTemplateCode"
            :rules="[{ max: 50, message: '长度在 0 到 50 个字符', trigger: 'change' }]"
            >
            <el-input
              size="small" v-model="aliyunForm.cancelDeliveryTemplateCode"
              type="textarea"
              :rows="2"
              @input="aliyunChange"
              max="50"

              placeholder="请填写取消配送提醒短信模板ID" clearable class=""/>
          </el-form-item>
        </div>

        <div class="flex-wrapper">
          <el-form-item label="航材退料提醒短信模板ID"
            prop="toolRejectedTemplateCode"
            :rules="[{ max: 50, message: '长度在 0 到 50 个字符', trigger: 'change' }]"
           >
            <el-input
              size="small" v-model="aliyunForm.toolRejectedTemplateCode"
              type="textarea"
              @input="aliyunChange"
              :rows="2"
              max="50"

              placeholder="请填写航材退料提醒短信模板ID" clearable class=""/>
          </el-form-item>

          <el-form-item label="航材退料取消提醒短信模板ID"
            prop="cancelRejectedTemplateCode"
            :rules="[{ max: 50, message: '长度在 0 到 50 个字符', trigger: 'change' }]"
           >
            <el-input
              size="small" v-model="aliyunForm.cancelRejectedTemplateCode"
              type="textarea"
              @input="aliyunChange"
              :rows="2"
              max="50"

              placeholder="请填写航材退料取消提醒短信模板ID" clearable class=""/>
          </el-form-item>
          <el-form-item label="找回密码验证码短信模板ID"
            prop="retrievePasswordTemplateCode"
            :rules="[{ max: 50, message: '长度在 0 到 50 个字符', trigger: 'change' }]"
            >
            <el-input
              size="small" v-model="aliyunForm.retrievePasswordTemplateCode"
              type="textarea"
              @input="aliyunChange"
              :rows="2"
              max="50"

              placeholder="请填写找回密码验证码短信模板ID" clearable class=""/>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAliyun('cancel')">取 消</el-button>
        <el-button type="primary" @click="handleAliyun('confirm')" :disabled="aliyunDisable">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { SYSCONFIG } from '../../libs/api'
import { aesDecrypt, aesEncrypt } from '../../libs/utils/encrypt'

export default {
  data() {
    return {
      formData: {
        id: '',
        // uuid: '',
        sysDockVersion: '', // 系统对接版本
        sysDockAdd: '', // 系统对接API地址
        smsSendMethod: '', // 信息发送方式
        enableAuth: '', // 启用AD认证
        loginMethod: '', // 客户端认证方式
        allowSameDept: '', // 允许领料员领取同部门航材包
        needLogin: '', // 领取航材必须登录
        needSweep: '', // 领取退料必须扫描退料单号
        checkRecordNumber: '', // 配送单号必须在ERP系统中存在
        wsdlUrl: '', // qrcode-api-wsdl 字段维护
        deliveryReceiverType: '', // 配送时录入领取人信息为
      },
      aliyunVisible: false,
      aliyunDisable: true,

      aliyunForm: {
        uuid: '',
        // 阿里云短信配置
        messageServerAddress: '', // 阿里云短信服务地址
        accessKeyId: '',
        accessKeySecret: '',
        signName: '', // 短信签名
        toolDeliveryTemplateCode: '', // 航材配送提醒短信模板ID
        cancelDeliveryTemplateCode: '', // 取消配送提醒短信模板ID
        toolRejectedTemplateCode: '', // 航材退料提醒短信模板ID
        cancelRejectedTemplateCode: '', // 航材退料取消提醒短信模板ID
        retrievePasswordTemplateCode: '' // 找回密码验证码短信模板id
      },
      rules: {
        loginMethod: { required: true, message: '请选择客户端登录认证方式', trigger: 'change' },
        smsSendMethod: { required: true, message: '请选择信息发送方式', trigger: 'change' }
      },
      GAMECO: 'GAMECO', // 默认系统对接版本
      loginMethodVal: '1', // 默认员工号
      smsSendMethodVal: '4', // 默认企业微信
      smsSendMethodVal2: '1', // 默认短信猫
      checkboxVal: ['enableAuth', 'allowSameDept', 'needLogin', 'needSweep', 'checkRecordNumber'],
      getInitDataUrl: SYSCONFIG.GET_LIST,
      restartUrl: SYSCONFIG.RESTART,
      checkboxEnableAD: true, // AD认证
      checkboxEnable: false, // 允许领料人领取同部门航材包
      enableSelectSendMethod: true, // 信息发送方式
      enableLoginMethod: false, // 客户端登录认证
    }
  },
  mounted() {
    this.getInitData()
  },
  methods: {
    aliyunChange() {
      this.aliyunDisable = false
    },
    save() {
      this.getFormData().then(formdata => {
        this.$http.post(SYSCONFIG.SAVE, formdata)
        .then(res => {
          if (res.data.code === 1) {
                this.handleMessage('success', res.data.msg || '保存系统配置成功')
          } else {
            this.handleMessage('error', res.data.msg || '保存系统配置成功失败')
          }
        })
      })

    },
    openAliyun() {
      this.$refs.aliyunForm && this.$refs.aliyunForm.resetFields()
      this.aliyunVisible = true
      this.$http.post(SYSCONFIG.MSG_CONFIG_GET)
        .then(res => {
          if (res.data.data) {

            // 初始化数据
            Object.keys(this.aliyunForm).forEach(key => {
              // if (key === 'accessKeySecret') {
              //   // this.loginForm.password = aesEncrypt(this.loginForm.password, 'USER')
              //   this.aliyunForm[key] = aesDecrypt(res.data.data[key], 'USER')
              // } else {
              //   this.aliyunForm[key] = res.data.data[key]
              // }
              this.aliyunForm[key] = res.data.data[key]
            })
          }
        })
    },
    handleAliyun(type) {
      if (type === 'confirm') { // 确定
        this.$refs.aliyunForm.validate(valid => {
          if (valid) {

            this.aliyunDisable = true
            const temp = { ...this.aliyunForm }
            // temp.accessKeySecret = aesEncrypt(temp.accessKeySecret, 'USER')

            this.$http.post(SYSCONFIG.MSG_CONFIG_SAVE, temp)
            .then(res => {
              if (res.data.code === 1) {
                this.handleMessage('success', res.data.msg || '保存阿里云配置成功')
                this.aliyunVisible = false
              } else {
                this.handleMessage('error', res.data.msg || '保存阿里云配置成功失败')
                this.aliyunVisible = false
              }
            })
          }
        })
      } else {
        this.aliyunVisible = false
        this.aliyunDisable = true
      }
      // this.$refs.aliyunForm.resetFields()
    },
    getInitData() {
      this.$http.post(this.getInitDataUrl)
        .then(res => {
          if (res.data.code !== 1) {
            console.error(res.data.msg || '获取下发配置到客户端初始化数据失败')
            return
          }
          this.formatInitData(res.data.data[0]) // 初始化表单数据
        })
    },
    formatInitData(data) { // 初始化表单数据 需要将这些后端返回的数值格式化成布尔值
      const selectData = ['smsSendMethod', 'loginMethod', 'sysDockVersion', 'sysDockAdd']
      // eslint-disable-next-line
      for (const key in this.formData) {
        // eslint-disable-next-line
        const val = data[key] || '' + '' // 将数字变成字符串
        if (this.checkboxVal.includes(key)) { // 处理复选框
          if (val === 1) {
            this.formData[key] = true
          } else {
            this.formData[key] = false
          }
        } else {
          // eslint-disable-next-line
          if (selectData.includes(key) && val === 'null') {
            this.formData[key] = ''
          } else {
            this.formData[key] = val + ''
          }

          // this.formData.deliveryReceiverType = '1'
        }
      }
    },
    formatCommitData() {
      // 将布尔值转成数字
      const formdata = { ...this.formData }
      // eslint-disable-next-line
      for ( const key in formdata) {
        if (this.checkboxVal.includes(key)) {
          if (formdata[key]) {
            formdata[key] = 1
          } else {
            formdata[key] = 0
          }
        }
      }
      return formdata
    },
    getFormData() {
      return new Promise((resolve) => {
        const formdata = this.formatCommitData() // 获取最终格式化后的表单数据
        // 表单校验
        this.$refs.searchForm.validate(valid => {
          if (valid) {
            // 校验系统对接API地址是否必填
            const requireSysDockAdd = this.checkSysDockAddRequire()
            if (!requireSysDockAdd) {
              return
            }
            // 校验 “系统对接API地址” 最后一个字符是否是“/”， 如果不是则自动补全。校验网址格式问题
            formdata.sysDockAdd = this.checkValidUrl(formdata.sysDockAdd)

            // this.configClientRequest(formdata)
            resolve(formdata)
          }
        })
      })
    },
    configClient() {
      this.getFormData().then(formdata => {
        this.configClientRequest(formdata)
      })
    },
    configClientRequest(formdata) {
      this.$http.post(this.restartUrl, formdata)
        .then(res => {
          if (res.data.code === 1) {
            this.handleNotify('success', '提示', '下发配置到客户端成功')
          } else {
            console.error(res.data.msg || '下发配置到客户端操作失败')
          }
        })
    },
    checkSysDockAddRequire() { // 验证系统对接API地址
      // 系统对接版本为GAMECO时候，验证系统对接API地址 必填，反之非必填
      const isGAMECOSelect = this.formData.sysDockVersion === this.GAMECO
      const sysDockAddVal = this.formData.sysDockAdd
      const wsdlUrlVal = this.formData.wsdlUrl
      const valid = /(http|ftp|https):\/\/[\w]/.test(sysDockAddVal)
      const valid2 = /(http|ftp|https):\/\/[\w]/.test(wsdlUrlVal)
      if (isGAMECOSelect) {
        if (!sysDockAddVal) {
          this.handleMessage('error', '请输入系统对接API地址！')
          return false
        }

        if (!wsdlUrlVal) {
          this.handleMessage('error', '请输入 qrcode-api-wsdl ！')
          return false
        }
      }
      if (sysDockAddVal && !valid) {
        this.handleMessage('error', '请输入合法的系统对接API地址！')
        return false
      }
      if (wsdlUrlVal && !valid2) {
        this.handleMessage('error', '请输入合法的qrcode-api-wsdl！')
        return false
      }
      return true
    },
    checkValidUrl(data) {
      if (!this.formData.sysDockAdd) { // 没有输入 系统对接API地址， 返回 ""
        return ''
      }
      const lastChart = data.charAt(data.length - 1) === '/'
      let param = data
      if (!lastChart) {
        param = `${data}/`
      }
      return param
    },
    handleNotify(type, title, message) { // 处理侧边提示信息框
      this.$notify({
        type,
        title,
        message
      })
    },
    handleMessage(type, message) {
      this.$message({
        message,
        type
      })
    },
    sysDockVersionChange() {
      const val = this.formData.sysDockVersion
      if (val === this.GAMECO) {
        this.isGAMECO()
      } else { // 当系统对接版本不是GAMECO时候
        this.notGAMECO()
      }
    },
    isGAMECO() {
      this.formData.enableAuth = true // AD认证

      // 允许领料人领取同部门航材包
      this.formData.allowSameDept = true
      this.checkboxEnable = false

      // 信息发送方式
      this.formData.smsSendMethod = this.smsSendMethodVal // 设置下拉框默认企业微信

      // 客户端登录认证
      this.formData.loginMethod = this.loginMethodVal // 设置该下拉框值为员工号
      this.enableLoginMethod = true

      // 配送单号必须在ERP系统中存在
      this.formData.checkRecordNumber = true
    },
    notGAMECO() {
      this.formData.enableAuth = false // AD认证 将该复选框取消选中状态

      // 允许领料人领取同部门航材包
      this.formData.allowSameDept = false
      this.checkboxEnable = true

      // 信息发送方式
      this.formData.smsSendMethod = this.smsSendMethodVal2 // 短信猫

      // 客户端登录认证
      this.enableLoginMethod = false

      // 配送单号必须在ERP系统中存在
      this.formData.checkRecordNumber = false
    }
  }
}
</script>
<style lang="scss" scoped>
$height32: 32px !important;
$width880: 880px;
$width990: 990px;
.content-wrapper{
  // display: flex;
  // justify-content: center;
  .search-form{
    border: 1px solid #eee;
    // width: $width990;
    /deep/.is-disabled{ // 设置禁用复选框样式
      .el-checkbox__inner{
        background: #f8f8f8b8;
      }
      & + .el-checkbox__label{
        color: #606266
      }
    }
    .flex-wrapper{
      // display: flex;
      // // width: $width880;
      // justify-content: center;
      /deep/.el-textarea__inner {
        width: 300px;
      }
    }
    .aliyun-message-wrapper {
      // width: 60%;
      display: flex;
      flex-wrap: wrap;
    }
    .checkbox-wrapper{
      display: flex;
      padding-left: 32px;
      .el-form-item__content{
        margin-right: 20px
      }
    }
    .btn-wrapper{
      text-align: center;
      width: $width880;
    }
    // 重新覆盖input框的样式，这是因为加了校验之后，input框默认是绿色边框
    /deep/.el-input input{
      border-color: #a5a0a069
    }
    /deep/input[disabled='disabled']{
      height: $height32;
      background: #fbf8f800;
      color: #606266;
    }
    /deep/input[readonly='readonly']{
      height: $height32;
    }
  }

  // 阿里云配置 accessKeySecret 密码框中的小眼睛隐藏
  /deep/.access-key-secret {
    .el-icon-view {
      display: none;
    }
  }
}
</style>
